import { Controller } from '@hotwired/stimulus'
import { post } from '@rails/request.js'

export default class extends Controller {
  connect() {
    const paginationLinks = this.element.querySelectorAll('a')

    paginationLinks.forEach(link => link.addEventListener('click', this.submit))
  }

  submit(event) {
    event.preventDefault()

    const url = new URL(event.target.href)
    const path = url.origin + url.pathname

    const urlParams = new URLSearchParams(url.search)

    const urlParamsObject = Object.fromEntries(urlParams)

    const searchFormParams = {
      emission_items: urlParams.getAll('emission_items[]'),
      categories: urlParams.getAll('categories[]'),
      scopes: urlParams.getAll('scopes[]'),
      report_division_entities: urlParams.getAll('report_division_entities[]')
    }

    const cleanParams = Object.assign(urlParamsObject, searchFormParams)

    post(path, {
      body: cleanParams,
      responseKind: 'turbo-stream'
    })
  }
}
